import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["date", "timeSelect", "slots"];

  connect() {
    if (this.dateTarget.value) {
      this.fetchAvailableSlots();
    }
  }

  dateChanged() {
    this.fetchAvailableSlots();
  }

  fetchAvailableSlots() {
    const serviceId = document.querySelector("#appointment_service_id").value;
    const providerId = document.querySelector(
      "#appointment_service_provider_id"
    ).value;
    const date = this.dateTarget.value;

    if (!serviceId || !providerId || !date) return;

    fetch(
      `/sites/${this.siteId}/available_slots?service_id=${serviceId}&provider_id=${providerId}&date=${date}`
    )
      .then((response) => response.json())
      .then((data) => {
        this.updateTimeSlots(data);
      });
  }

  updateTimeSlots(data) {
    this.slotsTarget.innerHTML = this.renderTimeSlots(data);
  }

  renderTimeSlots(data) {
    return `
      <div class="grid grid-cols-4 gap-2 mt-4">
        ${data.slots
          .map(
            (slot) => `
          <button type="button"
                  class="p-2 text-sm border rounded font-semibold transition-colors duration-150 ${
                    slot.available
                      ? "bg-white text-gray-900 shadow hover:bg-blue-100 cursor-pointer border-blue-400"
                      : "bg-gray-800 text-gray-400 border-gray-700 cursor-not-allowed opacity-60"
                  }"
                  ${!slot.available ? "disabled" : ""}
                  data-action="click->time-slots#selectTime"
                  data-time="${slot.time}">
            ${slot.formatted_time}
          </button>
        `
          )
          .join("")}
      </div>
    `;
  }

  selectTime(event) {
    this.timeSelectTarget.value = event.currentTarget.dataset.time;
    this.slotsTarget.querySelectorAll("button").forEach((btn) => {
      btn.classList.remove("ring-2", "ring-blue-500");
    });
    event.currentTarget.classList.add("ring-2", "ring-blue-500");
  }

  get siteId() {
    return document.querySelector("meta[name='site-id']").content;
  }
}
